<faxe-page-title></faxe-page-title>
<mat-list>
  @if (clientEvents?.length) {
  <mat-divider style="padding-bottom: 15px"></mat-divider>
  } @for (clientEvent of clientEvents; track clientEvent) {
  <mat-list-item style="padding-top: 10px">
    <img matListItemAvatar [src]="clientEvent.logoPath" alt="avatar" />
    <div matListItemTitle>Type {{ clientEvent.eventType }}</div>
    <div matListItemLine>Timestamp: {{ clientEvent?.timestamp }}</div>
    <div matListItemLine>{{ clientEvent?.msg }}</div>
    @if (clientEvent?.data) {
    <div matListItemLine>
      <mat-accordion>
        <mat-expansion-panel
          (opened)="panelOpenState.set(true)"
          (closed)="panelOpenState.set(false)"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>Data</mat-panel-title>
            <mat-panel-description> </mat-panel-description>
          </mat-expansion-panel-header>
          <ngx-json-viewer
            [expanded]="false"
            [json]="clientEvent?.data"
          ></ngx-json-viewer>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    }
  </mat-list-item>
  <mat-divider style="margin-top: 15px"></mat-divider>
  }
</mat-list>
